import {
  customizationPathname,
  endPathname,
} from '@order/utils/getNextStepHref'
import {
  useConfigConditionCheck,
  useConfigConditionGroupCheck,
} from 'features/config/useConfigCondition'
import { useMemo } from 'react'

export const useLensCustomizations = () => {
  const check = useConfigConditionCheck()
  const checkGroup = useConfigConditionGroupCheck()

  const customizations = useMemo(() => {
    return {
      corridor: checkGroup('lensCustomizations:corridor')?.any ?? false,
      doubleSided: check('lensCustomizations:doubleSided') ?? false,
      basic: check('lensCustomizations:basic') ?? false,
    }
  }, [check, checkGroup])

  return customizations
}

export const useConfigEndPath = () => {
  const customizations = useLensCustomizations()
  return useMemo(() => {
    if (Object.values(customizations).some((v) => v)) {
      return customizationPathname
    }
    return endPathname
  }, [customizations])
}
